import { render, staticRenderFns } from "./CheckItem.vue?vue&type=template&id=0276d033&"
import script from "./CheckItem.vue?vue&type=script&lang=js&"
export * from "./CheckItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports